import numeral from 'numeral';
export var dollarFormat = function dollarFormat(num, alwaysShowDecimals) {
  var format = alwaysShowDecimals ? '$0,0.00' : '$0,0[.]00';
  return numeral(num).format(format);
};
export var percentFormat = function percentFormat(num) {
  return numeral(num).format('0%');
};
export var numberFormat = function numberFormat(num) {
  return numeral(num).format('0,0');
};
export var formatPhoneNumber = function formatPhoneNumber(phoneString) {
  var p = phoneString ? phoneString.toString().replace(/[^0-9]/g, '') : '';
  var m = p.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m || p.length !== 10 ? p : "(".concat(m[1], ") ").concat(m[2], " - ").concat(m[3]);
};
export var showNumbersOnly = function showNumbersOnly(val) {
  return val ? val.replace(/[^0-9]/g, '') : val;
};